import { render, staticRenderFns } from "./DonationFail.vue?vue&type=template&id=6f856c7f&scoped=true"
import script from "./DonationFail.vue?vue&type=script&lang=js"
export * from "./DonationFail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f856c7f",
  null
  
)

export default component.exports